import React, { useEffect, useReducer } from "react"
import classNames from "classnames"
import Button from "../../Button/Button"
import ResourceTypeDropdown from "./wrappers/ResourceTypeDropdown"
import EventTypeDropdown from "./wrappers/EventTypeDropdown"
import DatePicker from "./wrappers/DatePicker"
import AccessTypeDropdown from "./wrappers/AccessTypeDropdown"
import FreeCheckbox from "./wrappers/FreeCheckbox"
import { ReactComponent as ArrowTopIcon } from "../../../images/icons/arrow-top.svg"
import { reducer, initState } from "./useReducer/reducer"
import {
  toggleCollapse,
  setWholeState,
  resetForm,
} from "./useReducer/actionCreators"
import styles from "./index.module.scss"

const ResourceSearchFilter = ({
  classes,
  searchParamGroup,
  onReset,
  onSubmit,
}) => {
  const [state, dispatch] = useReducer(reducer, initState)
  useEffect(() => {
    dispatch(setWholeState(searchParamGroup))
  }, [searchParamGroup])
  return (
    <div
      className={classNames(styles.filter, classes, {
        [styles.isCollapse]: state.isCollapse,
      })}
    >
      <div className={styles.header} onClick={() => dispatch(toggleCollapse())}>
        <p className={styles.caption}>All Filters</p>
        <div className={styles.collapseIcon}>
          <ArrowTopIcon />
        </div>
      </div>
      <div className={styles.form}>
        <div className={styles.body}>
          <div className={classNames(styles.item, styles.halfOfWidth)}>
            <ResourceTypeDropdown
              selectedType={state.values.resourceType}
              externalDispatch={dispatch}
            />
          </div>
          <div className={classNames(styles.item, styles.halfOfWidth)}>
            <EventTypeDropdown
              selectedType={state.values.eventType}
              externalDispatch={dispatch}
            />
          </div>
          <div
            className={classNames(
              styles.item,
              styles.dateField,
              styles.halfOfWidth,
            )}
          >
            <DatePicker
              fromDate={state.values.fromDate}
              toDate={state.values.toDate}
              externalDispatch={dispatch}
            />
          </div>
          <div className={classNames(styles.item, styles.halfOfWidth)}>
            <AccessTypeDropdown
              selectedType={state.values.accessType}
              externalDispatch={dispatch}
            />
          </div>
          <div className={styles.item}>
            <FreeCheckbox
              classes={styles.checkbox}
              checked={state.values.isFree}
              externalDispatch={dispatch}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            buttonStyle="outlined"
            className={styles.btn}
            onClick={() => {
              dispatch(resetForm())
              onReset()
            }}
          >
            Clear
          </Button>
          <Button className={styles.btn} onClick={() => onSubmit(state.values)}>
            Apply
          </Button>
        </div>
      </div>
    </div>
  )
}
export default ResourceSearchFilter
